export default __webpack_public_path__ + "static/media/raindrops.6dfeba40.jpg";